import { Tag } from 'antd'
import { CheckOutlined } from '@ant-design/icons'
import type { McpPlaybookInput } from '@/types/mcp'

export function InputsSummary({ inputs }: { inputs: McpPlaybookInput[] }) {
  const asked = inputs.filter((input) => !input.workedOut).map((input) => input.name)
  const workedOut = inputs.filter((input) => input.workedOut).map((input) => input.name)
  return (
    <>
      {asked.length > 0 && <span>Asks for: {asked.join(', ')}</span>}
      {workedOut.length > 0 && <span>Worked out for you: {workedOut.join(', ')}</span>}
    </>
  )
}

export default function PlaybookInputs({ inputs }: { inputs: McpPlaybookInput[] }) {
  return (
    <ul className="m-0 list-none space-y-1.5 p-0 text-sm text-gray-700">
      {inputs.map((input) => (
        <li key={input.name} className="flex flex-wrap items-baseline gap-x-2 gap-y-1">
          <span className="font-medium text-gray-900">{input.name}</span>
          {input.workedOut && (
            <Tag color="cyan" icon={<CheckOutlined />} className="!m-0">
              Worked out for you
            </Tag>
          )}
          {input.description && <span className="text-gray-500">{input.description}</span>}
        </li>
      ))}
    </ul>
  )
}
